import {
  object,
  number,
} from 'yup';

export const loginUserValidationSchema = object().shape({
  organizationId: number().required().label('The organization'),
});


// WEBPACK FOOTER //
// ./src/features/login/validation-schemas/loginUserValidationSchema.js